
export default {
  area: "长安路街道数智管理平台",
  objectName: "",
  //线上地址
  hostUrl: 'https://calzhsq.anluoyun.cn',
  apiHttpsUrl: 'https://calzhsq.anluoyun.cn/prod-api/',
  apiRequestUrl: 'https://calzhsq.anluoyun.cn/prod-api',
  apiUploadUrl: 'https://calzhsq.anluoyun.cn/prod-api/common/OssUploadImg',
  apiUploadFiles: 'https://calzhsq.anluoyun.cn/prod-api/common/OssUploadImg',
  apiUploadvideo: 'https://calzhsq.anluoyun.cn/prod-api/UploadFile/UploadQiniuVideo', 
  // 本地地址
  // hostUrl: 'http://192.168.1.16:8087',
  // apiHttpsUrl: 'http://192.168.1.16:8087',
  // apiRequestUrl: 'http://192.168.1.16:8087',
  // apiUploadUrl: 'http://192.168.1.16:8087/prod-api/common/OssUploadImg',
  // apiUploadFiles: 'http://192.168.1.16:8087/prod-api/common/OssUploadImg',
  // apiUploadvideo: 'http://192.168.1.16:8087/prod-api/UploadFile/UploadQiniuVideo',

  // 积分商城平台标识
  platformId: 'hy_zhsq',
}